/* Be Glowing Theme — theme.js (بدون مكتبات) */
(function () {
  'use strict';
  var T = window.theme || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- الأرقام والأسعار ---------- */
  var AR = ['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
  function ar(str) {
    str = String(str);
    if (!T.money || !T.money.arabic) return str;
    return str.replace(/[0-9]/g, function (d) { return AR[+d]; });
  }
  function group(n, dec) {
    var parts = n.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    var m = T.money || {};
    if (m.custom) {
      var s = group(cents / 100, cents % 100 === 0 ? 0 : 2);
      if (m.arabic) s = s.replace(/,/g, '٬').replace(/\./g, '٫');
      s = ar(s);
      return m.pos === 'before' ? (m.label + ' ' + s) : (s + ' ' + m.label);
    }
    var fmt = m.format || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return group(cents / 100, 0);
        case 'amount_with_comma_separator': return group(cents / 100, 2).replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
        case 'amount_no_decimals_with_comma_separator': return group(cents / 100, 0).replace(/,/g, '.');
        default: return group(cents / 100, 2);
      }
    }).replace(/<[^>]+>/g, '');
  }
  T.formatMoney = money;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.classList.remove('is-show'); }, 2200);
  }

  /* ---------- Overlay / Drawers ---------- */
  var overlay = function () { return $('[data-overlay]'); };
  function lock(on) { document.body.classList.toggle('lock', !!on); }
  function closeAll() {
    $$('.cart-drawer.is-open,.menu-drawer.is-open,.search-modal.is-open').forEach(function (e) { e.classList.remove('is-open'); });
    var o = overlay(); if (o) o.classList.remove('is-open');
    closeQuickView();
    lock(false);
  }
  function openDrawer(el) {
    if (!el) return;
    closeAll();
    el.classList.add('is-open');
    var o = overlay(); if (o) o.classList.add('is-open');
    lock(true);
  }
  function openCart() {
    if (T.cartType === 'page') { window.location.href = T.routes.cart; return; }
    openDrawer($('#CartDrawer'));
  }

  /* ---------- Cart ---------- */
  var cartCount = null;
  function setCount(n) {
    cartCount = n;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = ar(n); el.hidden = n === 0; });
    updateOffer(n);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: n } }));
  }
  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#CartDrawer');
    var cur = $('#CartDrawer');
    if (fresh && cur) {
      cur.innerHTML = fresh.innerHTML;
      ['style'].forEach(function (a) { if (fresh.getAttribute(a)) cur.setAttribute(a, fresh.getAttribute(a)); });
      if (openPanel) togglePanel(openPanel, true);
      setCount(parseInt(fresh.getAttribute('data-count') || '0', 10));
    }
  }
  function refreshCountFromServer() {
    return fetch(T.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; });
  }
  function cartRequest(url, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function (j) {
        if (j.sections && j.sections['cart-drawer']) renderDrawer(j.sections['cart-drawer']);
        else refreshCountFromServer();
        return j;
      });
  }
  function addItems(items, opts) {
    opts = opts || {};
    return cartRequest(T.routes.cartAdd + '.js', { items: items })
      .then(function (j) {
        if (window.location.pathname === T.routes.cart) { window.location.reload(); return j; }
        if (opts.silent) toast(T.strings.added);
        else if (T.cartType === 'page') toast(T.strings.added);
        else openCart();
        return j;
      })
      .catch(function (e) { toast((e && (e.description || e.message)) || T.strings.error); throw e; });
  }
  T.addItems = addItems;
  function changeLine(key, qty) {
    return cartRequest(T.routes.cartChange + '.js', { id: key, quantity: qty })
      .then(function () { if (window.location.pathname === T.routes.cart) window.location.reload(); })
      .catch(function (e) { toast((e && e.description) || T.strings.error); });
  }

  /* ---------- أدوات السلة: ملاحظة / كود خصم / مقترحات ---------- */
  var openPanel = null;
  function togglePanel(name, force) {
    var d = $('#CartDrawer') || document; var p = $('[data-cd-panel="' + name + '"]', d); if (!p) return;
    var show = force === true ? true : p.hidden;
    $$('[data-cd-panel]', d).forEach(function (x) { x.hidden = true; });
    $$('[data-cd-toggle]', d).forEach(function (x) { x.classList.remove('is-open'); });
    p.hidden = !show; openPanel = show ? name : null;
    var b = $('[data-cd-toggle="' + name + '"]', d); if (b) b.classList.toggle('is-open', show);
    if (show) { var f = $('input,textarea', p); if (f && force !== true) f.focus(); }
  }
  function applyDiscount(code) {
    return cartRequest(T.routes.cartUpdate + '.js', { discount: code }).then(function (c) {
      if (!code) return;
      var ok = (c.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
      var err = $('#CartDrawer [data-discount-error]'); if (err) err.hidden = ok;
    }).catch(function () { var err = $('#CartDrawer [data-discount-error]'); if (err) err.hidden = false; });
  }

  /* ---------- عرض ٣+١ (شريط التقدم) ---------- */
  function offerState(count) {
    var o = T.offer || {}; var goal = o.goal || 4; var mod = count % goal;
    if (count === 0) return { msg: o.empty, pct: 0 };
    if (mod === 0) return { msg: (o.done || '').replace('[gifts]', ar(Math.floor(count / goal))), pct: 100 };
    return { msg: (o.progress || '').replace('[remaining]', ar(goal - mod)), pct: mod / goal * 100 };
  }
  function updateOffer(count) {
    var st = offerState(count);
    $$('[data-offer-msg]').forEach(function (e) { e.textContent = st.msg; });
    $$('[data-offer-fill]').forEach(function (e) { e.style.width = st.pct + '%'; });
  }

  /* ---------- باقات الكمية ---------- */
  function tierCalc(unit, btn) {
    var q = +btn.dataset.qty || 1, type = btn.dataset.type, v = +btn.dataset.value || 0;
    var base = unit * q, total = base;
    if (type === 'percent') total = Math.round(base * (100 - v) / 100);
    else if (type === 'free') total = unit * Math.max(0, q - v);
    else if (type === 'fixed') total = Math.max(0, base - v * 100);
    return { qty: q, total: total, base: base, old: (type !== 'none' && total < base) ? base : 0, saving: base - total, pct: base ? Math.round((base - total) / base * 100) : 0 };
  }

  /* ---------- نموذج المنتج (صفحة المنتج + Quick view) ---------- */
  function initProduct(root) {
    if (!root || root.__init) return; root.__init = true;
    var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    var product; try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = $('form[action*="/cart/add"]', root) || $('form', root);
    var idInput = $('[data-variant-id]', root);
    var qtyHidden = $('[data-form-qty]', root);
    var propInput = $('[data-pack-property]', root);
    var qtyInput = $('[data-qty-input]', root);
    if (!qtyInput) { qtyInput = document.createElement('input'); qtyInput.value = 1; }
    var atc = $('[data-atc]', root);
    var packs = $$('[data-pack]', root);
    var nudge = $('[data-qv-nudge]', root);
    var section = root.closest('[data-product-section]') || root;
    var sticky = document.querySelector('[data-sticky-atc]');
    var isMain = !!root.closest('[data-product-section]');
    var variant = product.variants.find(function (v) { return String(v.id) === String(idInput && idInput.value); }) || product.variants[0];

    function activePack() { return packs.find(function (p) { return p.classList.contains('is-active'); }); }
    function qty() { return Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1); }

    function update() {
      var unit = variant.price;
      packs.forEach(function (p) {
        var t = tierCalc(unit, p);
        var pe = $('[data-pack-price]', p); if (pe) pe.textContent = money(t.total);
        var oe = $('[data-pack-old]', p); if (oe) { oe.textContent = money(t.old); oe.hidden = !t.old; }
        var be = $('[data-pack-badge]', p);
        if (be && p.dataset.badgeTpl) be.textContent = p.dataset.badgeTpl.replace('[saving]', money(t.saving)).replace('[price]', money(unit)).replace('[percent]', ar(t.pct) + '٪');
        var pe2 = $('[data-pack-pct]', p); if (pe2) { pe2.textContent = 'خصم ' + ar(t.pct) + '٪'; pe2.hidden = !t.pct; }
        if (p.dataset.nudgeTpl) p.dataset.nudge = p.dataset.nudgeTpl.replace('[saving]', money(t.saving)).replace('[price]', money(unit));
      });
      var ap = activePack();
      var t = ap ? tierCalc(unit, ap) : { qty: 1, total: unit };
      var total = t.total * qty();
      if (qtyHidden) qtyHidden.value = t.qty * qty();
      if (propInput) { propInput.disabled = !ap; propInput.value = ap ? ap.dataset.label : ''; }
      if (nudge) { nudge.textContent = ap ? (ap.dataset.nudge || '') : ''; nudge.hidden = !nudge.textContent; }
      var box = $('[data-packs]', root), sv = $('[data-pack-save]', root);
      if (box && sv) {
        var txt = '';
        if (ap && t.saving > 0 && box.dataset.saveTpl) {
          txt = box.dataset.saveTpl.replace('[label]', ap.dataset.label).replace('[unit]', money(Math.round(t.total / t.qty))).replace('[price]', money(unit))
            .replace('[unit_saving]', money(Math.round(t.saving / t.qty))).replace('[saving]', money(t.saving)).replace('[percent]', ar(t.pct) + '٪');
        } else if (box.dataset.nosaveTpl) txt = box.dataset.nosaveTpl;
        $('[data-pack-save-text]', sv).textContent = txt; sv.hidden = !txt; sv.classList.toggle('is-saving', !!(ap && t.saving > 0));
      }
      var label = variant.available ? (atc && atc.dataset.tpl ? atc.dataset.tpl.replace('[total]', money(total)) : '') : T.strings.soldout;
      if (atc) { if (label) atc.textContent = label; atc.disabled = !variant.available; }
      var bnb = $('[data-buy-now]', root), bnm = bnb && $('[data-bn-main]', bnb);
      if (bnm && bnb.dataset.tpl) bnm.textContent = bnb.dataset.tpl.replace('[total]', money(total));
      if (isMain) $$('[data-final-cta]').forEach(function (fc) { if (fc.dataset.tpl) fc.textContent = fc.dataset.tpl.replace('[total]', money(total)); });
      if (isMain && sticky) {
        var sb = $('[data-sticky-btn]', sticky), sl = $('[data-sticky-label]', sticky);
        if (sb) { sb.textContent = variant.available ? sb.dataset.tpl.replace('[total]', money(total)) : T.strings.soldout; sb.disabled = !variant.available; }
        var sqv = $('[data-sq-val]', sticky); if (sqv) sqv.textContent = ar(qty());
        if (sl) sl.textContent = ap ? (ap.dataset.label + (ap.dataset.note ? ' · ' + ap.dataset.note : '')) : (product.has_only_default_variant ? '' : variant.title);
      }
      /* المخزون */
      var st = $('[data-stock]', root), sj = $('[data-stock-inv]', root);
      if (st && sj) {
        var inv = -1; try { inv = JSON.parse(sj.textContent)[variant.id]; } catch (e) {}
        var th = +st.dataset.threshold || 15, on = inv > 0 && inv <= th;
        st.hidden = !on;
        if (on) { $('[data-stock-text]', st).textContent = st.dataset.tpl.replace('[count]', ar(inv)); var sb = $('[data-stock-bar]', st); if (sb) sb.style.width = Math.max(8, Math.round(inv / th * 100)) + '%'; }
      }
      /* بلوك السعر */
      var pp = $('[data-pp]', root), q = qty();
      var cmp = variant.compare_at_price > unit ? variant.compare_at_price : unit;
      var follow = !pp || pp.dataset.follow !== 'false';
      var nowP = follow ? t.total * q : unit;
      var wasP = follow ? Math.max(cmp * (ap ? t.qty : 1) * q, (t.base || unit) * q) : cmp;
      if (pp && pp.dataset.layout === 'unit') { var uu = Math.max(1, (ap ? t.qty : 1) * q); nowP = Math.round(nowP / uu / 100) * 100; wasP = Math.max(cmp, unit); }
      var sav = Math.max(0, wasP - nowP), pc = wasP ? Math.round(sav / wasP * 100) : 0;
      var pr = $('[data-price]', root); if (pr) pr.textContent = money(nowP);
      var cp = $('[data-compare]', root); if (cp) { cp.hidden = !sav; cp.textContent = money(wasP); }
      if (pp) {
        var bd = $('[data-pp-badge]', pp); if (bd) { bd.hidden = !sav; bd.textContent = pp.dataset.badgeTpl.replace('[percent]', ar(pc) + '٪').replace('[saving]', money(sav)); }
        var sv2 = $('[data-pp-save]', pp); if (sv2) { sv2.hidden = !sav; $('span', sv2).textContent = pp.dataset.saveTpl.replace('[saving]', money(sav)).replace('[percent]', ar(pc) + '٪'); }
        var un = $('[data-pp-unit]', pp); var units = pp.dataset.layout === 'unit' ? 1 : (ap ? t.qty : 1) * q;
        if (un) { un.hidden = !(follow && units > 1 && pp.dataset.unitTpl); un.textContent = (pp.dataset.unitTpl || '').replace('[unit]', money(Math.round(nowP / units))); }
      }
      /* بادچ الصورة */
      var ib = isMain ? $('[data-img-badge]', section) : null;
      if (ib) {
        var mode = ib.dataset.mode, bs = 0, bp = 0;
        if (mode === 'best') packs.forEach(function (x) { var tt = tierCalc(unit, x); if (tt.pct > bp) { bp = tt.pct; bs = tt.saving; } });
        else if (mode === 'pack' && ap && t.saving > 0) { bp = t.pct; bs = t.saving; }
        if (!bp && variant.compare_at_price > unit) { bs = variant.compare_at_price - unit; bp = Math.round(bs / variant.compare_at_price * 100); }
        ib.hidden = !bp; ib.textContent = ib.dataset.tpl.replace('[percent]', ar(bp) + '٪').replace('[saving]', money(bs));
      }
    }

    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        packs.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        p.classList.add('is-active'); p.setAttribute('aria-checked', 'true'); update();
      });
    });

    var wrap = $('[data-qty-wrap]', root);
    if (wrap) {
      wrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-qty-plus]')) qtyInput.value = qty() + 1;
        else if (e.target.closest('[data-qty-minus]')) qtyInput.value = Math.max(1, qty() - 1);
        else return;
        update();
      });
    }

    var picker = $('[data-variant-picker]', root);
    if (picker) {
      picker.addEventListener('change', function () {
        var opts = [];
        $$('[data-option-index]', picker).forEach(function (el) {
          if (el.tagName === 'SELECT' || el.checked) opts[+el.dataset.optionIndex] = el.value;
        });
        var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        if (!v) return;
        variant = v; if (idInput) idInput.value = v.id;
        if (isMain && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
        if (v.featured_media) showSlide(section, v.featured_media.id);
        update();
        root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
      });
    }

    function submit(buyNow) {
      if (!variant.available) return;
      var item = { id: variant.id, quantity: parseInt(qtyHidden ? qtyHidden.value : qty(), 10) || 1 };
      var extra = []; $$('[data-addon]', root).forEach(function (a) { if (a.checked) extra.push({ id: +a.dataset.addon, quantity: 1 }); });
      if (propInput && !propInput.disabled && propInput.value) { item.properties = {}; item.properties[propInput.name.replace(/^properties\[|\]$/g, '')] = propInput.value; }
      var btn = buyNow || atc; if (btn) btn.classList.add('is-loading');
      if (buyNow) {
        fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item].concat(extra) }) })
          .then(function (r) { if (!r.ok) throw r; window.location.href = T.routes.root + 'checkout'; })
          .catch(function () { btn.classList.remove('is-loading'); toast(T.strings.error); });
        return;
      }
      closeQuickView();
      addItems([item].concat(extra)).finally(function () { if (btn) btn.classList.remove('is-loading'); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    var bn = $('[data-buy-now]', root); if (bn) bn.addEventListener('click', function () { submit(bn); });

    if (isMain && sticky) {
      var sb = $('[data-sticky-btn]', sticky);
      if (sb) sb.addEventListener('click', function () { submit(); });
      var sq = $('[data-sticky-qty]', sticky);
      if (sq) sq.addEventListener('click', function (e) { var bt = e.target.closest('[data-sq]'); if (!bt) return; qtyInput.value = Math.max(1, qty() + (+bt.dataset.sq)); update(); });
      if (sticky.dataset.stickyAtc === 'scroll' && atc) {
        var chkSticky = function () { if (!document.contains(atc)) return; var r = atc.getBoundingClientRect(); sticky.classList.toggle('is-hidden', r.bottom > 0); };
        window.addEventListener('scroll', chkSticky, { passive: true }); chkSticky();
      }
    }
    update();
  }

  /* ---------- الجاليري ---------- */
  function showSlide(scope, mediaIdOrIndex) {
    var slides = $$('[data-slide]', scope); if (!slides.length) return;
    var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaIdOrIndex); });
    if (idx < 0) idx = +mediaIdOrIndex || 0;
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
    $$('[data-thumb]', scope).forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    var sn = $('[data-slide-num]', scope); if (sn) sn.textContent = ar(idx + 1);
  }

  /* ---------- Quick view ---------- */
  function closeQuickView() {
    var m = $('#QuickView'); if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true');
    if (!$('.cart-drawer.is-open,.menu-drawer.is-open')) lock(false);
  }
  function openQuickView(url) {
    var m = $('#QuickView'); if (!m) { window.location.href = url; return; }
    var box = $('.modal__content', m);
    box.innerHTML = '<div class="modal__loading">…</div>';
    closeAll(); m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); lock(true);
    var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view';
    fetch(u).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var qv = doc.querySelector('[data-qv]');
      if (!qv) { window.location.href = url; return; }
      box.innerHTML = ''; box.appendChild(document.importNode(qv, true));
      initProduct($('[data-qv]', box));
    }).catch(function () { window.location.href = url; });
  }

  /* ---------- البحث ---------- */
  var searchTimer;
  function predictive(q) {
    var out = $('[data-search-results]'); if (!out) return;
    if (!T.predictive || q.length < 2) { out.innerHTML = ''; return; }
    fetch(T.routes.search + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
        out.innerHTML = ps.map(function (p) {
          return '<a href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="">' : '') +
            '<div style="display:flex;flex-direction:column"><b style="font-weight:600">' + p.title.replace(/</g, '&lt;') + '</b><span class="muted" style="font-size:13px">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></div></a>';
        }).join('');
      }).catch(function () {});
  }

  /* ---------- Events (delegation) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target, el;

    if ((el = t.closest('[data-cart-open]'))) { if (T.cartType !== 'page') { e.preventDefault(); openCart(); } return; }
    if (t.closest('[data-cart-close]') || t.closest('[data-overlay]') || t.closest('[data-menu-close]')) { closeAll(); return; }
    if (t.closest('[data-qv-close]')) { closeQuickView(); return; }
    if (t.closest('[data-menu-open]')) { openDrawer($('[data-menu-drawer]')); return; }

    if ((el = t.closest('[data-quick-view]'))) { e.preventDefault(); e.stopPropagation(); openQuickView(el.dataset.quickView); return; }
    if ((el = t.closest('[data-add-variant]'))) {
      e.preventDefault(); e.stopPropagation(); if (el.disabled) return;
      el.classList.add('is-loading');
      addItems([{ id: +el.dataset.addVariant, quantity: +(el.dataset.qty || 1) }], { silent: el.hasAttribute('data-silent') })
        .finally(function () { el.classList.remove('is-loading'); });
      return;
    }
    if ((el = t.closest('[data-add-items]'))) {
      e.preventDefault(); e.stopPropagation();
      var items; try { items = JSON.parse(el.dataset.addItems); } catch (err) { return; }
      el.classList.add('is-loading');
      addItems(items).finally(function () { el.classList.remove('is-loading'); });
      return;
    }
    if (t.closest('[data-filter-open]')) { var fdw = $('[data-filter-drawer]'); if (fdw) { fdw.hidden = false; lock(true); } return; }
    if (t.closest('[data-filter-close]')) { var fdc = $('[data-filter-drawer]'); if (fdc) { fdc.hidden = true; lock(false); } return; }
    if ((el = t.closest('[data-view]'))) { setView(el.closest('form') || document, +el.dataset.view, true); return; }
    if ((el = t.closest('[data-rq]'))) {
      var w = el.closest('[data-row-qty]'), sp = $('span', w), n = Math.max(1, (parseInt(w.dataset.n || '1', 10)) + (+el.dataset.rq));
      w.dataset.n = n; sp.textContent = ar(n); var ab = $('[data-add-variant]', w.parentNode); if (ab) ab.dataset.qty = n; return;
    }
    if ((el = t.closest('[data-bundle-swap]'))) {
      var sw; try { sw = JSON.parse(el.dataset.bundleSwap); } catch (err) { return; }
      el.classList.add('is-loading');
      fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: sw.updates }) })
        .then(function (r) { if (!r.ok) throw r; return addItems([{ id: sw.add, quantity: 1 }], { silent: true }); })
        .then(function () { toast('اتحولت للباقة ووفّرتي ✓'); })
        .catch(function () { el.classList.remove('is-loading'); toast(T.strings.error); });
      return;
    }
    if ((el = t.closest('[data-cd-toggle]'))) { togglePanel(el.dataset.cdToggle); return; }
    if ((el = t.closest('[data-discount-apply]'))) { var inp = $('#CartDrawer [data-discount-input]'); var code = inp ? inp.value.trim() : ''; if (code) { el.classList.add('is-loading'); applyDiscount(code); } return; }
    if ((el = t.closest('[data-discount-remove]'))) { applyDiscount(''); return; }
    if ((el = t.closest('[data-up-prev],[data-up-next]'))) {
      var tr = $('[data-up-track]', el.closest('.cd-up')); if (!tr) return;
      var rtl = getComputedStyle(tr).direction === 'rtl'; var dir = el.hasAttribute('data-up-next') ? 1 : -1;
      tr.scrollBy({ left: (rtl ? -dir : dir) * tr.clientWidth, behavior: 'smooth' }); return;
    }
    if ((el = t.closest('[data-line-change]'))) { e.preventDefault(); el.classList.add('is-loading'); changeLine(el.dataset.lineChange, Math.max(0, +el.dataset.qty)); return; }
    if ((el = t.closest('button[data-href]'))) { window.location.href = el.dataset.href; return; }
    if ((el = t.closest('[data-thumb]'))) { showSlide(el.closest('[data-gallery]'), +el.dataset.thumb); return; }

    if ((el = t.closest('[data-faq-cat]'))) {
      var wrap = el.closest('[data-faq]'); var cat = el.dataset.faqCat;
      $$('[data-faq-cat]', wrap).forEach(function (b) { b.classList.toggle('is-active', b === el); });
      $$('[data-cat]', wrap).forEach(function (q) { q.hidden = !(cat === 'all' || q.dataset.cat === cat); });
      return;
    }
    if ((el = t.closest('[data-video-play]'))) {
      var card = el.closest('[data-video-card]'); var v = $('video', card);
      if (v) { if (v.paused) { v.play(); card.classList.add('is-playing'); } else { v.pause(); card.classList.remove('is-playing'); } }
      else { var tp = $('template[data-embed]', card); if (tp) { card.appendChild(tp.content.cloneNode(true)); card.classList.add('is-playing'); } }
      return;
    }
    if ((el = t.closest('[data-card-link]')) && !t.closest('a,button')) { window.location.href = el.dataset.cardLink; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAll(); var fdk = $('[data-filter-drawer]'); if (fdk && !fdk.hidden) { fdk.hidden = true; lock(false); } }
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-discount-input]')) { e.preventDefault(); var b = $('#CartDrawer [data-discount-apply]'); if (b) b.click(); }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-discount-input]') && e.inputType === 'insertLineBreak') return;

  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-sort]')) { var u = new URL(window.location.href); u.searchParams.set('sort_by', t.value); u.searchParams.delete('page'); window.location.href = u.toString(); }
    if (t.matches('[data-filter-input]') || t.matches('[data-sort-auto]')) {
      var f = t.closest('form'); var fd = new FormData(f);
      var q = []; fd.forEach(function (v, k) { if (v !== '') q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); });
      window.location.href = (f.getAttribute('action') || window.location.pathname) + (q.length ? '?' + q.join('&') : '');
    }
    if (t.matches('[data-cart-note]')) { fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: t.value }) }); }
  });

  /* فتح أكورديون واحد في المرة */
  document.addEventListener('toggle', function (e) {
    var d = e.target; if (!d.matches || !d.matches('details') || !d.open) return;
    var g = d.closest('[data-acc-group="true"]'); if (!g) return;
    $$('details[open]', g).forEach(function (x) { if (x !== d) x.open = false; });
  }, true);

  /* ---------- Init ---------- */
  function initRecommendations(scope) {
    $$('[data-recommendations]', scope).forEach(function (el) {
      if (el.__rec) return; el.__rec = true;
      fetch(el.dataset.recommendations).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.querySelector('.pcard')) el.innerHTML = fresh.innerHTML; else el.hidden = true;
      });
    });
  }
  /* ---------- أنيميشن الظهور ---------- */
  var RV_SEL = '.sec-head,.grid>*,.scroller>*,.promo,.cta,.cdown,.trust,.build,.routine,.pdp-reviews,.pacc,.page-head,.faq-list>*,.box,.iwt>*,.rich>*,.coll-banner';
  var rvObs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (en) {
    en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); rvObs.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function initReveal(scope) {
    if (!document.documentElement.classList.contains('anim') || !rvObs) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && Shopify.designMode) return;
    $$(RV_SEL, scope).forEach(function (el) {
      if (el.closest('.cart-drawer,.modal,.menu-drawer,.pdp__info,.hero') || el.classList.contains('rv')) return;
      var sib = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
      if (el.parentNode && (el.parentNode.classList.contains('grid') || el.parentNode.classList.contains('scroller'))) el.style.setProperty('--rv-d', Math.min(sib * 70, 420) + 'ms');
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) return; /* اللي ظاهر أصلاً مايستخباش */
      el.classList.add('rv'); rvObs.observe(el);
    });
  }

  /* ---------- اتفرجتي عليها مؤخراً ---------- */
  function initRecent(scope) {
    $$('[data-recent]', scope).forEach(function (sec) {
      var idx = []; try { idx = JSON.parse($('[data-ss-index]').textContent); } catch (e) { return; }
      var by = {}; idx.forEach(function (p) { by[p.h] = p; });
      var list = []; try { list = JSON.parse(localStorage.getItem('nabtah-rv') || '[]'); } catch (e) {}
      var cur = sec.dataset.current, lim = +sec.dataset.limit || 4;
      var items = list.filter(function (h) { return h !== cur && by[h]; }).slice(0, lim).map(function (h) { return by[h]; });
      if (!items.length) return;
      var e = function (x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      $('[data-recent-list]', sec).innerHTML = items.map(function (p) {
        return '<div class="pcard pcard--minimal"><div class="pcard__media" style="--img-ratio:1/1"><a href="' + e(p.u) + '">' + (p.i ? '<img src="' + e(p.i) + '" alt="' + e(p.t) + '" loading="lazy">' : '') + '</a>' +
          (p.a ? '<button type="button" class="pcard__overlay-btn" data-quick-view="' + e(p.u) + '">اختاري العرض</button>' : '') + '</div>' +
          '<div class="pcard__info"><a class="pcard__name" href="' + e(p.u) + '">' + e(p.t) + '</a><span class="pcard__price">' + e(p.pf) + (p.cf ? ' <s>' + e(p.cf) + '</s>' : '') + '</span></div></div>';
      }).join('');
      sec.hidden = false;
    });
  }

  /* ---------- نافذة الاشتراك ---------- */
  function initPopup() {
    var el = $('[data-popup]'); if (!el || el.__p) return; el.__p = true;
    if (window.Shopify && Shopify.designMode) { el.addEventListener('click', function (e) { if (e.target.closest('[data-popup-close]')) { el.classList.remove('is-open'); lock(false); } }); return; }
    var key = 'nabtah-popup', days = +el.dataset.days || 7, last = 0;
    try { last = +localStorage.getItem(key) || 0; } catch (e) {}
    if (el.classList.contains('is-open')) { lock(true); }
    function show() {
      if (el.classList.contains('is-open')) return;
      if (el.dataset.hideCart === 'true' && (cartCount || +el.dataset.count) > 0) return;
      if (document.body.classList.contains('lock')) return;
      el.classList.add('is-open'); lock(true);
      try { localStorage.setItem(key, Date.now()); } catch (e) {}
    }
    function hide() { el.classList.remove('is-open'); lock(false); try { localStorage.setItem(key, Date.now()); } catch (e) {} }
    el.addEventListener('click', function (e) { if (e.target.closest('[data-popup-close]')) hide(); });
    if (el.classList.contains('is-open')) return;
    if (last && Date.now() - last < days * 86400000) return;
    setTimeout(show, (+el.dataset.delay || 12) * 1000);
    if (el.dataset.exit === 'true') document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 10) show(); });
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy]'); if (!c) return;
    var v = c.dataset.copy; var done = function () { toast('اتنسخ ✓'); };
    if (navigator.clipboard) navigator.clipboard.writeText(v).then(done, done); else done();
  });

  /* ---------- حجز السلة ---------- */
  var resT;
  function initReserve() {
    var el = $('#CartDrawer [data-reserve]') || $('[data-reserve]'); clearInterval(resT); if (!el) return;
    var mins = +el.dataset.min || 10, key = 'nabtah-reserve', end = 0;
    try { end = +localStorage.getItem(key) || 0; } catch (e) {}
    if (!end || end < Date.now() - 3600000) { end = Date.now() + mins * 60000; try { localStorage.setItem(key, end); } catch (e) {} }
    var txt = $('[data-reserve-text]', el);
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { txt.textContent = el.dataset.done; el.classList.add('is-done'); clearInterval(resT); return; }
      var t = ar(String(Math.floor(left / 60)).padStart(2, '0')) + ':' + ar(String(left % 60).padStart(2, '0'));
      txt.innerHTML = el.dataset.tpl.replace('[time]', '<b>' + t + '</b>');
    }
    tick(); resT = setInterval(tick, 1000);
  }
  document.addEventListener('cart:updated', function () { initReserve(); });

  /* ---------- زرار «اطلبي الآن» في آخر صفحة المنتج + التابات ---------- */
  document.addEventListener('click', function (e) {
    var fc = e.target.closest('[data-final-cta]');
    if (fc) {
      e.preventDefault();
      var sec = document.querySelector('[data-product-section]');
      var target = sec && ($('[data-buy-now]', sec) || $('[data-atc]', sec));
      if (target && fc.dataset.action === 'buy') target.click();
      else if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var tb = e.target.closest('[data-tab]');
    if (tb) {
      var box = tb.closest('[data-tabs]'); if (!box) return;
      $$('[data-tab]', box).forEach(function (x) { var on = x === tb; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
      $$('[data-panel]', box).forEach(function (p) { p.hidden = p.dataset.panel !== tb.dataset.tab; });
    }
    var rt = e.target.closest('[data-rv-tab]');
    if (rt) {
      var rb = rt.closest('[data-rv]'); if (!rb) return;
      $$('[data-rv-tab]', rb).forEach(function (x) { x.classList.toggle('is-active', x === rt); });
      $$('[data-rv-list]', rb).forEach(function (l) { l.hidden = l.dataset.rvList !== rt.dataset.rvTab; });
    }
    var rp = e.target.closest('[data-rv-page]');
    if (rp) {
      var rb2 = rp.closest('[data-rv-list]'); if (!rb2) return;
      var n = rp.dataset.rvPage;
      $$('[data-rv-page]', rb2).forEach(function (x) { x.classList.toggle('is-active', x === rp); });
      $$('[data-rv-item]', rb2).forEach(function (it) { it.hidden = it.dataset.rvItem !== n; });
    }
    var rs = e.target.closest('[data-rv-sort]');
    if (rs) {
      var rb3 = rs.closest('[data-rv]'); if (!rb3) return;
      $$('[data-rv-sort]', rb3).forEach(function (x) { x.classList.toggle('is-active', x === rs); });
      $$('[data-rv-list]', rb3).forEach(function (l) {
        var items = $$('[data-rv-item]', l), wrap = items[0] && items[0].parentNode; if (!wrap) return;
        var mode = rs.dataset.rvSort;
        items.sort(function (a, b) {
          if (mode === 'helpful') return (+b.dataset.helpful || 0) - (+a.dataset.helpful || 0);
          if (mode === 'photos') return (+b.dataset.photos || 0) - (+a.dataset.photos || 0);
          return (+a.dataset.order || 0) - (+b.dataset.order || 0);
        });
        var per = +l.dataset.per || 5;
        items.forEach(function (it, i) { it.dataset.rvItem = String(Math.floor(i / per) + 1); wrap.appendChild(it); it.hidden = i >= per; });
        var pag = $('[data-rv-pages]', l); if (pag) wrap.appendChild(pag);
        $$('[data-rv-page]', l).forEach(function (x, i) { x.classList.toggle('is-active', i === 0); });
      });
    }
  });

  /* ---------- ميعاد الشحن ---------- */
  var DAYS = ['الأحد', 'الاتنين', 'التلات', 'الأربع', 'الخميس', 'الجمعة', 'السبت'];
  var MONTHS = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
  function initDelivery(scope) {
    $$('[data-delivery]', scope).forEach(function (el) {
      if (el.__d) return; el.__d = true;
      var cut = +el.dataset.cutoff || 15, skip = (el.dataset.skip || '').split(/[,،\s]+/).filter(Boolean).map(Number);
      function addBiz(d, n) { var x = new Date(d); var c = 0; while (c < n) { x.setDate(x.getDate() + 1); if (skip.indexOf(x.getDay()) === -1) c++; } return x; }
      function fmt(d) { return DAYS[d.getDay()] + (el.dataset.format === 'words' ? '، ' : ' ') + ar(d.getDate()) + ' ' + MONTHS[d.getMonth()]; }
      function tick() {
        var now = new Date(), end = new Date(now); end.setHours(cut, 0, 0, 0);
        var shipToday = now < end && skip.indexOf(now.getDay()) === -1;
        var main = $('[data-dlv-main]', el), rng = $('[data-dlv-range]', el);
        if (shipToday) {
          var left = Math.floor((end - now) / 1000), h = Math.floor(left / 3600), m = Math.floor(left % 3600 / 60), sec = left % 60;
          var t = el.dataset.format === 'words' ? (ar(h) + ' ساعة و' + ar(m) + ' دقيقة') : ((h ? ar(h) + ' س ' : '') + ar(String(m).padStart(2, '0')) + ' د ' + ar(String(sec).padStart(2, '0')) + ' ث');
          main.innerHTML = el.dataset.tplBefore.replace('[time]', '<span class="dlv__time">' + t + '</span>');
        } else main.textContent = el.dataset.tplAfter.replace('[time]', '');
        var base = shipToday ? now : addBiz(now, 0);
        var from = addBiz(base, +el.dataset.min || 2), to = addBiz(base, +el.dataset.max || 5);
        rng.textContent = el.dataset.tplRange.replace('[from]', fmt(from)).replace('[to]', fmt(to));
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- العدّاد ---------- */
  function initCountdown(scope) {
    $$('[data-countdown]', scope).forEach(function (sec) {
      if (sec.__cd) return; sec.__cd = true;
      var mode = sec.dataset.mode, end, key = 'nabtah-cd-' + sec.dataset.key, hrs = +sec.dataset.hours || 24;
      function evergreen() {
        var now = Date.now(), v = 0;
        try { v = +localStorage.getItem(key) || 0; } catch (e) {}
        if (!v || v < now) { v = now + hrs * 3600000; try { localStorage.setItem(key, v); } catch (e) {} }
        return v;
      }
      function midnight() { var d = new Date(); d.setHours(23, 59, 59, 999); return d.getTime(); }
      function parse() { var t = (sec.dataset.end || '').replace(' ', 'T'); var v = Date.parse(t); return isNaN(v) ? midnight() : v; }
      end = mode === 'evergreen' ? evergreen() : mode === 'daily' ? midnight() : parse();
      var els = {}; ['d', 'h', 'm', 's'].forEach(function (k) { els[k] = $('[data-cd="' + k + '"]', sec); });
      var pad = function (n) { return ar(String(n).padStart(2, '0')); };
      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          if (sec.dataset.expired === 'hide') { sec.hidden = true; return; }
          if (sec.dataset.expired === 'restart') { end = mode === 'evergreen' ? (function () { try { localStorage.removeItem(key); } catch (e) {} return evergreen(); })() : mode === 'daily' ? midnight() + 1000 : Date.now() + hrs * 3600000; left = end - Date.now(); }
          else left = 0;
        }
        var t = Math.floor(left / 1000), d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), s2 = t % 60;
        if (!els.d) h += d * 24;
        if (els.d) els.d.textContent = pad(d); if (els.h) els.h.textContent = pad(h); if (els.m) els.m.textContent = pad(m); if (els.s) els.s.textContent = pad(s2);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- عدد أعمدة صفحة المنتجات ---------- */
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }
  function setView(scope, n, save) {
    var g = $('[data-coll-grid]', scope) || $('[data-coll-grid]'); if (!g) return;
    var mob = isMobile(); g.style.setProperty(mob ? '--cols-mv' : '--cols', n);
    $$('[data-view]', scope).forEach(function (b) { b.classList.toggle('is-active', +b.dataset.view === n && (mob ? b.classList.contains('hide-desktop') : b.classList.contains('hide-mobile'))); });
    if (save) { try { localStorage.setItem('nabtah-view-' + (mob ? 'm' : 'd'), n); } catch (e) {} }
  }
  function initView(scope) {
    var g = $('[data-coll-grid]', scope); if (!g) return;
    var mob = isMobile(), n = 0;
    try { n = +localStorage.getItem('nabtah-view-' + (mob ? 'm' : 'd')) || 0; } catch (e) {}
    if (!n) n = +getComputedStyle(g).getPropertyValue(mob ? '--cols-m' : '--cols-d') || (mob ? 2 : 4);
    setView(g.closest('form') || document, n, false);
  }

  function init(scope) {
    $$('[data-product-info]', scope).forEach(initProduct);
    initReveal(scope); initCountdown(scope); initView(scope); initDelivery(scope); initReserve(); initRecent(scope); initPopup();
    initRecommendations(scope);
    if ($('[data-offer-progress]', scope)) {
      if (cartCount === null) refreshCountFromServer(); else updateOffer(cartCount);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* محرر الثيم */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.id === 'shopify-section-cart-drawer') openCart();
    var pp = e.target.querySelector && e.target.querySelector('[data-popup]'); if (pp) { pp.classList.add('is-open'); lock(true); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var pp = e.target.querySelector && e.target.querySelector('[data-popup]'); if (pp) { pp.classList.remove('is-open'); lock(false); }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest && e.target.closest('details'); if (d) d.open = true;
    if (e.target.closest && e.target.closest('#shopify-section-cart-drawer')) openCart();
  });
})();
